module.exports = __webpack_public_path__ + "img/retina.e1a4a642.svg";